import { type VariantProps, cva } from "class-variance-authority";
import type { ComponentProps } from "react";
import styles from "./Icon.module.css";

const iconVariants = cva(styles.base, {
  variants: {
    size: {
      xsmall: styles.xsmall,
      small: styles.small,
      default: styles.default,
    },
  },
  defaultVariants: {
    size: "default",
  },
});

type ButtonProps = ComponentProps<"span"> & VariantProps<typeof iconVariants>;

export function Icon({ className, size, ...props }: ButtonProps) {
  return <span {...props} className={iconVariants({ className, size })} />;
}
